const states = {
  agent_monitoring_details: {
    groups: {
      columns: [],
      data: []
    },
    expanded_group: {
      group: null,
      agents: {
        columns: [],
        data: []
      },
    },
    selected_agent: {
      agent: null,
      live_chats: {},
      active_chat: {
        chat_item: null,
        messages: [],
        profile: {}
      }
    },
    loaders: {
      agent_list_loading: false,
      report_sharing: false,
    }
  }
};

export default states;



// WEBPACK FOOTER //
// ./src/data/redux/agent_monitoring_details/states.js